import { service } from '@/utils/request'

export default {
	// 查询
	getList(params) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/quiz/quizList',
			method: 'get',
            params
		})
	},
	// 更新
	update(data) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/quiz/addOrUpdateQuiz',
			method: 'post',
			data: data
		})
	},
	// 删除
	delete(params) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/quiz/deleteQuiz',
			method: 'post',
			params
		})
	},
    //根据课程源id获取关联的课程列表
    getRelateCourseList: (params) => {
        return service({
            url: '/cloud/course/v1/admin/coursesource/associationCourseList',
            method: 'get',
            params: params
        })
    },
	get(quizId) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/quizInfo/' + quizId,
			method: 'get'
		})
	},
    // 导出数据
	exportExcel(params) {		
		return service({
			url: '/cloud/course/v1/admin/coursesource/exportQuiz',
			method: 'get',
			params,
			responseType: 'blob'
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/contentManage/paperManage.js